module.exports = __webpack_public_path__ + "img/icon13.7336027c.svg";